import { render } from "./CapsuleComponents.vue?vue&type=template&id=2e8d5eca"
import script from "./CapsuleComponents.vue?vue&type=script&lang=js"
export * from "./CapsuleComponents.vue?vue&type=script&lang=js"

import "./CapsuleComponents.vue?vue&type=style&index=0&id=2e8d5eca&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon-sg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__